import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import '../index.scss';

export default class BookerAccountInfo extends React.Component {
  constructor(props) {
    super(props);

    // const { business } = this.props;

    this.state = {
      BusinessID: '',
      Login: '',
      Password: '',
      mandatoryFieldError: false,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.validate = this.validate.bind(this);
  }

  onInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  onNextButtonClick() {
    const { BusinessID, Login, Password } = this.state;

    const data = {
      BusinessID,
      Login,
      Password,
      client: 'PHOREST',
    };
    const validationResult = this.validate(data);

    if (validationResult) {
      this.props.postZenotiAccountInfo(data);
    }
  }

  validate(data) {
    if (!data.BusinessID || !data.Login || !data.Password) {
      this.setState({
        mandatoryFieldError: true,
      });

      return false;
    }

    this.setState({
      mandatoryFieldError: false,
    });

    return true;
  }

  render() {
    const { BusinessID, Login, Password, mandatoryFieldError } = this.state;
    const { softwares } = this.props;
    return (
      <div className="authorize-access">
        <form className="authorize-access__form">
          {mandatoryFieldError ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Fields marked in red are mandatory!
            </p>
          ) : null}
          {softwares.isBookerAccountInfoSaveFail ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Unable to save account information
            </p>
          ) : null}
          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">Enter your Phorest Business ID *</p>
            <input
              type="text"
              name="BusinessID"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={BusinessID}
              onChange={this.onInputChange}
              autoComplete="false"
            />
          </div>

          {/* <a className="authorize-access__help-text" data-tip data-for="locationidhelp">
                  Hint: Your Zenoti Account Name is the same as the leading
                  part of the URL for your Zenoti online account
          </a> */}

          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">Enter your Phorest Login *</p>
            <input
              type="text"
              name="Login"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={Login}
              onChange={this.onInputChange}
              autoComplete="false"
            />
          </div>

          {/* <a className="authorize-access__help-text" data-tip data-for="locationidhelp">
                  Hint: You can find instrutions on how to generate an API key
                  by going to the following link and referring to the Overview
          </a> */}
          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">Password *</p>
            <input
              type="password"
              name="Password"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={Password}
              onChange={this.onInputChange}
              autoComplete="false"
            />
          </div>

        </form>
        <div className="authorize-access__actions">
          <button className="btn btn--secondary btn--lg" type="button" onClick={this.props.onBackClick}>
            Previous
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={this.onNextButtonClick}
            disabled={softwares.isSavingBookerAccountInfo}
          >
            {!softwares.isSavingBookerAccountInfo ? 'Next' : 'Saving...'}
          </button>
        </div>
      </div>
    );
  }
}

BookerAccountInfo.defaultProps = {
  postZenotiAccountInfo: () => {},
  onBackClick: () => {},
};

BookerAccountInfo.propTypes = {
  postZenotiAccountInfo: PropTypes.func,
  onBackClick: PropTypes.func,
  softwares: PropTypes.shape().isRequired,
};
